<template>
    <div class='pa-3'>
      <v-card>
        <v-card-title>
          <h3>Histórico de retornos do banco</h3>
        </v-card-title>
        
        <v-divider/>

        <v-card-text>
          <v-row>
              <v-col cols=12 sm=4 md=6>
                  <v-text-field v-model="search" prepend-icon="mdi-domain" label="Número do título" clearable></v-text-field>
              </v-col>
              <!--
              <v-col cols=12 sm=8 md=4>
                <v-file-input
                  v-model="arquivoRetorno"
                  accept=".ret"
                  label="Arquivo de retorno do banco"
                ></v-file-input>
              </v-col>
              <v-col cols=12 sm=4 md=2>
                <v-btn
                  :loading="loadRetorno"
                  @click="processarRetorno()"
                  class="mt-3"
                  dark
                  block
                  color="primary"
                  >processar</v-btn
                >
              </v-col>              
              -->
          </v-row>

           <v-data-table
                :items="faturamentos"
                :headers="headers"
                :search="search"
                :loading="loadFatura">
                <template v-slot:[`item.dataVencimentoBoleto`]="{ item }">
                  {{ $moment(item.dataVencimentoBoleto).format("L") }}
                </template>
                <template v-slot:[`item.dataCreditoPagamentoBoleto`]="{ item }">
                  {{ $moment(item.dataCreditoPagamentoBoleto).format("L") }}
                </template>
                <template v-slot:[`item.valorBoleto`]=" { item } ">
                  R$ {{formatPrice(item.valorBoleto)}}
                </template>
                <template v-slot:[`item.valorRecebido`]=" { item } ">
                  R$ {{formatPrice(item.valorRecebido)}}
                </template>
              </v-data-table>              
        </v-card-text>
      </v-card>

      <AlertSystem :snackbar="system.snackbar"/>
    </div>
</template>

<script>
import AlertSystem from "../components/AlertSystem.vue";

export default {
    name: 'RetornoBanco',
    components: { AlertSystem },

    data: () => ({
        headers: [
            {text: "Convênio", value: "numeroConvenio", width: "14%"},
            {text: "Titulo", value: "numeroTituloCobranca", width: "14%"},
            {text: "Data vencimento", value: "dataVencimentoBoleto", width: "14%"},
            {text: "Valor boleto ", value: "valorBoleto", width: "10%"},
            {text: "Data Pagamento", value: "dataCreditoPagamentoBoleto", width: "14%"},
            {text: "Valor pago ", value: "valorRecebido", width: "10%"},            
        ],      
        search:"",
        faturamentos: [],
        loadRetorno: false,
        arquivoRetorno: null,

        system: {
          snackbar: {},
          alertInfo: [],
          alertError: false,
        }
    }),

    methods: {
        getRetornos () {
            this.axios.get('/faturamentos/getRetorno', {
              params:{                
              }
            }).then( res => {
                this.faturamentos = res.data                
            })
        },
        formatPrice(value) {
          return value.toFixed(2)
                      .replace('.', ',')
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        processarRetorno() {
          this.loadRetorno = true;

          let formData = new FormData();
          formData.append(`files`, this.arquivoRetorno);

          this.axios.post(
            "faturamentos/retornos",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(res => {
              this.system.snackbar = {
                snackbar: true,
                text: res.data,
                color: "green",
              };
              this.arquivoRetorno = null;
            })
            .catch(e => {
              this.system.snackbar = {
                snackbar: true,
                text: e.response.data.files[0],
                color: "red",
              };
            })
            .finally(() => {
              this.loadRetorno = false;
            });
        },
    },
    mounted() {
      this.getRetornos()      
    }
}
</script>